import { Component, computed, input, Input, OnInit, signal } from '@angular/core'
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms'

import { InputTextModule } from 'primeng/inputtext'

import { ErrorMessageComponent } from 'app/_shared/components/error-message/error-message.component'

@Component({
  selector: 'app-input',
  imports: [InputTextModule, ReactiveFormsModule, ErrorMessageComponent],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss'
})
export class InputComponent implements OnInit {
  @Input() control: FormControl | AbstractControl
  inputType = signal<string>('')
  type = input<string>('text')
  placeholder = input<string>()
  name = input<string>('This field')
  id = input<string>()
  label = input<string>()
  errorMessage = input<string>('is required!')
  emailMessage = computed(() => {
    if (this.type() === 'email') {
      return 'address must be valid!'
    }
    return ''
  })
  inputControl: FormControl

  ngOnInit(): void {
    this.inputType.set(this.type())
    this.inputControl = this.control as FormControl
  }

  showHidePassword($event: MouseEvent) {
    $event.preventDefault()
    if (this.inputType() === 'password') {
      this.inputType.set('text')
    } else {
      this.inputType.set('password')
    }
  }
}
